module.exports = __webpack_public_path__ + "img/step4-06.6b66df72.jpg";